import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';

// Super admin accounts to create
const SUPER_ADMIN_ACCOUNTS = [
  {
    email: 'work.goyalco@gmail.com',
    password: 'goyal@123',
    displayName: 'Goyal Co Admin',
    role: 'super_admin'
  },
  {
    email: 'avularudrasekharreddy@gmail.com',
    password: 'goyal@123',
    displayName: 'Avula Rudra Sekhar Reddy',
    role: 'super_admin'
  }
];

export const createSuperAdminAccounts = async () => {
  const results = [];
  
  for (const account of SUPER_ADMIN_ACCOUNTS) {
    try {
      console.log(`Creating account for ${account.email}...`);
      
      // Create Firebase Auth user
      const userCredential = await createUserWithEmailAndPassword(
        auth, 
        account.email, 
        account.password
      );
      
      // Update display name
      await updateProfile(userCredential.user, {
        displayName: account.displayName
      });
      
      // Create user document in Firestore
      const userRef = doc(db, 'users', userCredential.user.uid);
      await setDoc(userRef, {
        displayName: account.displayName,
        email: account.email,
        photoURL: '',
        createdAt: new Date(),
        selectedApp: null,
        role: account.role
      });
      
      results.push({
        success: true,
        email: account.email,
        uid: userCredential.user.uid,
        message: 'Account created successfully'
      });
      
      console.log(`✅ Successfully created ${account.email}`);
      
    } catch (error) {
      console.error(`❌ Error creating ${account.email}:`, error);
      
      let errorMessage = error.message;
      if (error.code === 'auth/email-already-in-use') {
        errorMessage = 'Account already exists';
      }
      
      results.push({
        success: false,
        email: account.email,
        error: errorMessage
      });
    }
  }
  
  return results;
};

// Function to run the account creation
export const runAdminAccountCreation = async () => {
  console.log('🚀 Starting super admin account creation...');
  
  try {
    const results = await createSuperAdminAccounts();
    
    console.log('\n📊 Account Creation Results:');
    results.forEach(result => {
      if (result.success) {
        console.log(`✅ ${result.email}: ${result.message}`);
      } else {
        console.log(`❌ ${result.email}: ${result.error}`);
      }
    });
    
    const successCount = results.filter(r => r.success).length;
    console.log(`\n🎉 Created ${successCount}/${results.length} accounts successfully`);
    
    return results;
  } catch (error) {
    console.error('💥 Fatal error during account creation:', error);
    throw error;
  }
};
